import Crud from '../views/PurchaseType/Crud'
import Entity from '../views/PurchaseType/Add'


let routes = {
    path: '/purchase_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/purchase_types/add',
            name: 'NewPurchaseType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de compra',
                breadcrumb: [
                    {
                        text: 'Tipos de compra',
                        active: false,
                        to: '/purchase_types',
                    },
                    {
                        text: 'Adicionar tipo de compra',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/purchase_types/edit/:id?',
            name: 'EditPurchaseType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de compra',
                breadcrumb: [
                    {
                        text: 'Tipos de compra',
                        active: false,
                        to: '/purchase_types',
                    },
                    {
                        text: 'Editar tipo de compra',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/purchase_types',
            name: 'list-purchase-types',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de compra',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
